import React, { memo } from 'react';

import styles from '@/components/BottomNavigation/BottomNavigation.module.scss';
import BottomNavigationSlot from '@/components/BottomNavigation/BottomNavigationSlot';
import { BottomNavigationItem } from '@/components/BottomNavigation/types';

interface ItemLinkProps {
  item: BottomNavigationItem;
  index: number;
}

const ItemLink: React.FC<ItemLinkProps> = memo(({ item, index }) => (
  <div className={styles.slot} key={index} data-testid="slot">
    <a
      className={styles.link}
      href={item.url || ''}
      target={item.target || ''}
      rel="noopener noreferrer"
    >
      <BottomNavigationSlot item={item} />
    </a>
  </div>
));

export default ItemLink;
